import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["checked", "id", "name", "required", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TpxLabel = _resolveComponent("TpxLabel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", {
      class: "a-checkbox",
      checked: _ctx.isChecked,
      id: _ctx.id,
      name: _ctx.name,
      required: _ctx.isRequired,
      type: "checkbox",
      value: _ctx.value,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change', $event.target.checked)))
    }, null, 40, _hoisted_1),
    _createVNode(_component_TpxLabel, {
      colour: "current",
      content: _ctx.label,
      for: _ctx.id,
      isRequired: _ctx.isRequired
    }, null, 8, ["content", "for", "isRequired"])
  ], 64))
}